import { type CustomField } from '@webapp/core/entities/internal/CustomField'
import { EditablePOCustomFieldTextField } from '@webapp/modules/purchasing/features/rename-po-custom-field/views/EditablePOCustomFieldTextField'
import { useEditablePOCustomFieldTextFieldPresenter } from './useEditablePOCustomFieldTextFieldPresenter'

export interface IEditablePOCustomFieldTextFieldPresenterProps {
  field: CustomField
  allFields: CustomField[]
  onSuccess?: () => void
}

export const EditablePOCustomFieldTextFieldPresenter = ({
  field,
  allFields,
  onSuccess,
}: IEditablePOCustomFieldTextFieldPresenterProps) => {
  const {
    data: { inputValue, status },
    handlers: { handleChange, handleCommit, handleEscape },
  } = useEditablePOCustomFieldTextFieldPresenter({
    field,
    allFields,
    onSuccess,
  })

  return (
    <EditablePOCustomFieldTextField
      value={inputValue}
      status={status}
      onChange={handleChange}
      onCommit={handleCommit}
      onEscape={handleEscape}
    />
  )
}

EditablePOCustomFieldTextFieldPresenter.displayName =
  'EditablePOCustomFieldTextFieldPresenter'
